import { SelectableOption } from 'types/SelectableOption';

export const mapArrayIntoOptions = <TArray extends any[], TValueKey extends keyof TArray[number]>(
  array: TArray,
  labelKey: keyof TArray[number],
  valueKey: TValueKey,
): SelectableOption<TArray[number][TValueKey]>[] =>
  array.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));
